import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Input, Tooltip, Modal } from 'components';
import { CleanIcon, EyeBlackIcon } from 'assets/icons';
import moment from 'moment';
import { QuoteService } from 'services';
import { Globals, Constants, Colors, Print } from 'utils';
import ModalSend from './modal-quote';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	service: ''
}

class Quotes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha de solicitud',
			'Tipo de Cirugía',
			'Médico tratante',
			'Solicitud',
			'Estatus',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Cotizacion Cirugías',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await QuoteService.clinic.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			user_id: this.props.user?.id,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		if (!res.continue) {
			this.props.history.replace('/clinic/home');
			Globals.showError("Lo sentimos, para entrar al módulo de cotizaciones debe realizar el pago de su plan");
		}
		else {
			this.setState({
				data: res.quotes.rows,
				last_page: res.quotes.count
			});
		}
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	view = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await QuoteService.clinic.download({
			quote_id: item?.id
		});
	    Print(Constants.BASE_STORAGE + res.url);
	}

	send = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	getColor = (status: number) => {
		switch(status) {
			case Constants.QUOTE_RESPONSE_STATUS.ACTIVE:
				return Colors.green;
			break;

			case Constants.QUOTE_RESPONSE_STATUS.INACTIVE:
				return Colors.danger;
			break;
		}
	}

	getStatus = (status: number) => {
		switch(status) {
			case Constants.QUOTE_RESPONSE_STATUS.ACTIVE:
				return "Enviado";
			break;

			case Constants.QUOTE_RESPONSE_STATUS.INACTIVE:
				return "Pendiente";
			break;
		}
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="clinic-quotes">
				<Modal
		          className="modal-clinic-send-quote"
		          visible={ visible }
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalSend
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-4">
						<Input
							value={ this.state.form.search }
							name="search"
							label="Buscar por médico tratante"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-4">
						<Input
							value={ this.state.form.service }
							name="service"
							label="Tipo de Cirugía"
							placeholder="Buscar"
							className="input-table"
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-4"></div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Desde"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'since'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.since }
						/>
					</div>
					<div className="col-md-4">
						<DatePicker
							placeholder="Hasta"
							onChange={ (text: string) => {
								this.change({
									target: {
										value: text,
										name: 'until'
									}
								},() => this.load(true));
							} }
							value={ this.state.form.until }
						/>
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table title="Historial de Cotización" data={ this.state.data.length } rightAlign={[ 5 ]} header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						const status = i.response ? Constants.QUOTE_RESPONSE_STATUS.ACTIVE : Constants.QUOTE_RESPONSE_STATUS.INACTIVE;

						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD-MM-YYYY') }</td>
								<td>{ i?.service?.name }</td>
								<td>{ i?.user?.name }</td>
								<td>
									<a href="#" onClick={ (e: any) => this.view(e,i) }>Ver</a>
								</td>
								<td className="status" style={{
									color: this.getColor(status)
								}}>{ this.getStatus(status) }</td>
								<td className="text-right">
									{
										i.response && (
											<Tooltip title="Ver">
												<a target="_blank" className="link-icon" href={ Constants.BASE_STORAGE + i?.response?.file }>
													<img src={ EyeBlackIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										!i.response && (
											<Tooltip title="Cotizar">
												<a className="link-icon link-quote" href="#" onClick={ (e: any) => this.send(e,i) }>
													Cotizar
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Quotes);